<template>
  <div class="lg:hidden" ref="mobile-nav">

    <transition v-if="this.isOpen"
        enter-class="transition ease-linear duration-300"
        enter-active-class="opacity-0"
        enter-to-class="opacity-100"
        leave-class="transition ease-linear duration-300"
        leave-active-class="opacity-100"
        leave-to-class="opacity-0"
    >
    <div class="fixed inset-0 flex z-40">

      <div class="fixed inset-0" aria-hidden="true">
        <div class="absolute inset-0 bg-gray-600 opacity-75"></div>
      </div>

      <div class="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-white">
        <div class="absolute top-0 right-0 -mr-12 pt-2">
          <button @click="closeSidebar" class="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none  focus:ring-inset focus:ring-white">
            <span class="sr-only">Close sidebar</span>
            <!-- Heroicon name: x -->
            <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div class="mt-5 flex-1 h-0 overflow-y-auto">
          <nav class="px-2">
            <navigation :user="user"/>
          </nav>
        </div>
      </div>
      <div class="flex-shrink-0 w-14" aria-hidden="true">
        <!-- Dummy element to force sidebar to shrink to fit close icon -->
      </div>
    </div>

    </transition>

  </div>
</template>

<script>
  import Navigation from "./Navigation";

  export default {
    name: 'MobileLeftNavigation',
    components: {Navigation},
    props: {
      user: {}
    },
    created() {
      this.emitter.on('open_sidebar_nav', () => this.isOpen = true)

      window.addEventListener('resize', this.onResize)
    },
    data() {
      return {
        isOpen: false,
      }
    },
    methods: {
      closeSidebar() {
        this.isOpen = false;
      },
      onResize() {
        if (window.innerWidth >= 1024) {
          this.closeSidebar()
        }
      },
    },
  }
</script>
